<template>
  <div class="sion-login-container">
    <div class="sion-login-signin">
      <cube-form>
        <cube-form-group>
          <div class="sign-box">
            <div class="sign-input">
              <cube-input v-model="phone" type="number" :clearable="true" placeholder="请输入要绑定的手机号码"></cube-input>
            </div>
            <div class="sign-label" style="width:33%;textAlign:right">
              <label for>
                <span class="get-code" v-if="waiting" @click="getCheck">获取验证码</span>
                <span v-else class="react">重新获取({{time}})</span>
              </label>
            </div>
          </div>
        </cube-form-group>
        <cube-form-group>
          <div class="sign-box">
            <div class="sign-input">
              <cube-input type="number" v-model="checkNum" placeholder="请输入验证码"></cube-input>
            </div>
          </div>
        </cube-form-group>
      </cube-form>
    </div>
    <cube-form-group>
      <cube-button :disabled="disabled" @click="complete">立即绑定</cube-button>
      <div class="sion-btn" @click="out">取消</div>
    </cube-form-group>
  </div>
</template>
<script type="text/ecmascript-6">
import {toast} from '@/common/api/api.js';
import {getStaffPhoneSign,updateStaffPhone} from '@/common/api';
export default {
  data() {
    return {
      phone: "",
      checkNum: "",
      disabled: true,
      waiting: true,
      time: 90
    };
  },
  watch: {
    checkNum(value) {
      if (value) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    }
  },
  methods: {
    complete() {
      updateStaffPhone({
        signCode:this.checkNum,
        phone:this.phone
      }).then(res=>{
        if(res.code == 200){
          toast(this,res.message);
          sessionStorage.setItem("phone",this.phone)
          setTimeout(() => {
            this.$router.go(-1)
          }, 1000);
        }else{
          toast(this,res.message,'error')
        }
      })
    },
    out(){this.$router.go(-1)},
    getCheck() {
      let phoneReg = new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/);
      if (!phoneReg.test(this.phone)) {
        toast(this, "请输入正确手机号", "error");
        return
      };
      this.time = 60;
      this.waiting = false;
      var self = this;
      let timeout = setInterval(function() {
        self.time--;
        if (self.time == 0) {
          self.waiting = true;
          window.clearTimeout(timeout);
        }
      }, 1000);
      getStaffPhoneSign({
          phone:this.phone
      }).then(res=>{
          if(res == 200){
              toast(this,'验证码已发送');
          }else{
              toast(this,res.message,'error');
          }
      })
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../assets/stylus/index.styl';
.sign-label{
  font-size:16px;
}
.get-code{
  font-size:15px;
  font-family:PingFang SC;
  font-weight:400;
  color:rgba(53,53,53,1);
}
.react {
  font-size: 14px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  opacity: 0.4;
}

.cube-input {
  width: 200px;
}
</style>